import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import ErrorBoundary from './views/ErrorBoundary';
import { CollaborationView } from './collaboration_view';

const WorksheetTemplateView = React.lazy(() => import('./authoring/index'));

const LazyLoadedWorksheetTemplateView = (props) => (
  <React.Suspense fallback={<>...</>}>
    <WorksheetTemplateView {...props} />
  </React.Suspense>
);

window.parent.postMessage('SLED.performance.initialLoad', '*');

const App = () => (
  <ErrorBoundary>
    <Router>
      <Switch>
        <Route
          component={LazyLoadedWorksheetTemplateView}
          path="/worksheettemplates/:uuid"
        />
        <Route
          component={LazyLoadedWorksheetTemplateView}
          path="/worksheettemplates"
        />
        <Route component={CollaborationView} path="/" />
      </Switch>
    </Router>
  </ErrorBoundary>
);

export default App;
